// @flow

import { smsRoute } from 'server2';

import BaseController from './base';

import type { IController } from '../contracts';

export default class DefaultController
	extends BaseController
	implements IController {

	_getCheckRequestModel = () => {
		return {
			Phone: this._model.Phone.toJS(),
		};
	}

	_getVerifyRequestModel = () => {
		return {
			phone: this._model.Phone.toJS(),
			key: this._model.Key.toJS(),
			code: this._model.Code.toJS(),
		};
	}
	
	_getCheckRequestRoute = (): Array<string> => {
		return [
			smsRoute.prefix,
			smsRoute.phoneChecking,
			smsRoute.send,
		];
	}

	_getVerifyRequestRoute = (): Array<string> => {
		return [
			smsRoute.prefix,
			smsRoute.phoneChecking,
			smsRoute.verify,
		];
	}
	
	_sendCheckRequest = (): Promise<any> => {
		const route = this._getCheckRequestRoute();
		const model = this._getCheckRequestModel();

		return this._api.any.post(route, { body: { ...model } });
	}
	
	_sendVerifyRequest = (): Promise<any> => {
		const route = this._getVerifyRequestRoute();
		const model = this._getVerifyRequestModel();
		
		return this._api.any.get(route, { query: { ...model } });
	}
}